import "./App.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import News from "./pages/News";
import Founder from "./pages/Founder";
import Services from "./pages/Services";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import MainLayout from "./layouts/MainLayout";
import { Route, Routes } from "react-router-dom";
import SingleManager from "./pages/SingleManager";
import { AuthProvider } from "./providers/AuthProvider";
import ProtectedRoute from "./components/ProtectedRoute";
import SingleInstitution from "./pages/SingleInstitution";
import { SearchProvider } from "./components/Header/SearchContext";
import ToasterProvider from "./components/providers/ToasterProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SearchProvider>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<MainLayout />}>
                <Route path="/home" element={<HomePage />} />
                <Route path="/news" element={<News />} />
                <Route path="/news/:id" element={<News />} />
                <Route path="/founder" element={<Founder />} />
                <Route path="/services/:id" element={<Services />} />
                <Route path="/managers/:id" element={<SingleManager />} />
                <Route
                  path="/institutions/:id"
                  element={<SingleInstitution />}
                />
              </Route>
            </Route>
          </Routes>
        </SearchProvider>
        <ToasterProvider />
      </AuthProvider>
    </QueryClientProvider>
  );
}
